import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './FlipCards.css';
import { IoSettingsOutline } from "react-icons/io5";
import { SlPeople } from "react-icons/sl";
import { TbInfoOctagon } from "react-icons/tb";
import { SiCrystal } from "react-icons/si";
import { FaServer, FaEnvelope, FaCloud } from "react-icons/fa";
import { FaComputer } from "react-icons/fa6";
import { Link } from 'react-router-dom';

const FlipCards = () => {
  const cards = [
    {
      title: "Networking",
      frontIcon: <SlPeople />,
      backTitle: "Networking Services",
      backText: "Campus-wide network infrastructure and services for seamless connectivity.",
      link: "/services-network",
      email: "netadm@cc.iitd.ac.in"
    },
    {
      title: "Software",
      frontIcon: <IoSettingsOutline />,
      backTitle: "Software Solutions",
      backText: "Licensed software and development solutions for academic excellence.",
      link: "/services-software",
      email: "scisoft@cc.iitd.ac.in"
    },
    {
      title: "Web Services",
      frontIcon: <TbInfoOctagon />,
      backTitle: "Web Services",
      backText: "Hosting and web application development services for the institute.",
      link: "/services-web-services",
      email: "webgroup@cc.iitd.ac.in"
    },
    {
      title: "ERP",
      frontIcon: <SiCrystal />,
      backTitle: "ERP Services",
      backText: "Enterprise Resource Planning solutions for institutional management.",
      link: "/services-erp",
      email: "eadminhelp@iitd.ac.in"
    },
    {
      type: "dual",
      left: {
        title: "HPC",
        frontIcon: <FaServer />,
        backTitle: "High Performance Computing",
        backText: "Advanced computing resources for research and complex computations.",
        link: "https://supercomputing.iitd.ac.in/",
        email: "hpchelp@iitd.ac.in"
      },
      right: {
        title: "Baadal",
        frontIcon: <FaCloud />,
        backTitle: "Baadal Cloud Services",
        backText: "Baadal is a management and orchestration software for the IITD private cloud for high performance computing.",
        link: "https://baadal.iitd.ac.in/baadal",
        email: "baadalsupport@cc.iitd.ac.in"
      }
    },
    {
      title: "CSC Labs Booking",
      frontIcon: <FaComputer />,
      backTitle: "CSC Labs Booking",
      backText: "CSC Labs Booking software accepts lab booking requests from the Faculty Course Coordinators for Teaching Lab Courses, Quizzes, Mid-Sem Exams, End-Sem Exams, Workshops, Seminars, Trainings, Recruitment-exams etc.",
      link: "https://labbookings.csc.iitd.ac.in/",
      email: "jaya@cc.iitd.ac.in"
    }
  ];

  const getAllEmails = (emailString) => {
    if (!emailString) return [];
    return emailString.split(',').map(email => email.trim()).filter(email => email !== '');
  };

  return (
    <div className="container py-4">
      <div className="row g-4">
        <div className='d-flex justify-content-center'>
          <h1 className="alumni-title text-uppercase mt-4 mb-4">
            <span style={{color:"#686464"}}>Quick </span>Links
          </h1>
        </div>
        {cards.map((card, index) => {
          if (card.type === "dual") {
            return (
              <div key={index} className="col-md-4">
                <div className="d-flex gap-3" style={{height: 'auto'}}>
                  {/* Left Half - HPC */}
                  <div style={{flex: 1}}>
                    <Link to={card.left.link} className="text-decoration-none">
                      <div className="flip-card">
                        <div className="flip-card-inner">
                          <div className="flip-card-front">
                            <div className="card h-100 border-0">
                              <div className="card-body d-flex flex-column justify-content-center align-items-center text-center p-2">
                                <div className={`card-icon ${card.left.frontIcon.type === IoSettingsOutline ? 'rotate-icon' : ''}`} style={{fontSize: '2.5rem'}}>
                                  {card.left.frontIcon}
                                </div>
                                <h3 className="card-title mt-2 mb-2" style={{fontSize: '1.1rem', fontWeight: '600'}}>{card.left.title}</h3>
                                <div className="email-section-front mt-1">
                                  {getAllEmails(card.left.email).map((email, idx) => (
                                    <div key={idx} className="email-front d-flex align-items-center justify-content-center gap-1" style={{marginBottom: '3px'}}>
                                      <FaEnvelope size={9} />
                                      <small className="email-text-front" style={{fontSize: '0.7rem'}}>
                                        {email}
                                      </small>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flip-card-back">
                            <div className="card h-100 border-0">
                              <div className="card-body d-flex flex-column justify-content-center align-items-center text-center p-2">
                                <h3 className="card-title servicestitle mb-2" style={{fontSize: '0.95rem', fontWeight: '600'}}>{card.left.backTitle}</h3>
                                <p className="card-text servicesdesc m-0 mb-2" style={{fontSize: '0.75rem', lineHeight: '1.3'}}>
                                  {card.left.backText}
                                </p>
                                <div className="email-section-back mt-auto">
                                  <hr style={{opacity:"1", margin: '6px 0'}}/>
                                  <small style={{fontSize: '0.7rem'}}>Email:</small>
                                  <div className="email-back">
                                    {getAllEmails(card.left.email).map((email, idx) => (
                                      <div key={idx} className="email-item d-flex align-items-center justify-content-center gap-1">
                                        <FaEnvelope size={8} />
                                        <span style={{fontSize: '0.65rem'}}>{email}</span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>

                  {/* Right Half - Cloud */}
                  <div style={{flex: 1}}>
                    <Link to={card.right.link} className="text-decoration-none">
                      <div className="flip-card">
                        <div className="flip-card-inner">
                          <div className="flip-card-front">
                            <div className="card h-100 border-0">
                              <div className="card-body d-flex flex-column justify-content-center align-items-center text-center p-2">
                                <div className={`card-icon ${card.right.frontIcon.type === IoSettingsOutline ? 'rotate-icon' : ''}`} style={{fontSize: '2.5rem'}}>
                                  {card.right.frontIcon}
                                </div>
                                <h3 className="card-title mt-2 mb-2" style={{fontSize: '1.1rem', fontWeight: '600'}}>{card.right.title}</h3>
                                <div className="email-section-front mt-1">
                                  {getAllEmails(card.right.email).map((email, idx) => (
                                    <div key={idx} className="email-front d-flex align-items-center justify-content-center gap-1" style={{marginBottom: '3px'}}>
                                      <FaEnvelope size={9} />
                                      <small className="email-text-front" style={{fontSize: '0.7rem'}}>
                                        {email}
                                      </small>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flip-card-back">
                            <div className="card h-100 border-0">
                              <div className="card-body d-flex flex-column justify-content-center align-items-center text-center p-2">
                                <h3 className="card-title servicestitle mb-2" style={{fontSize: '0.95rem', fontWeight: '600'}}>{card.right.backTitle}</h3>
                                <p className="card-text servicesdesc m-0 mb-2" style={{fontSize: '0.75rem', lineHeight: '1.3'}}>
                                  {card.right.backText}
                                </p>
                                <div className="email-section-back mt-auto">
                                  <hr style={{opacity:"1", margin: '6px 0'}}/>
                                  <small style={{fontSize: '0.7rem'}}>Email:</small>
                                  <div className="email-back">
                                    {getAllEmails(card.right.email).map((email, idx) => (
                                      <div key={idx} className="email-item d-flex align-items-center justify-content-center gap-1">
                                        <FaEnvelope size={8} />
                                        <span style={{fontSize: '0.65rem'}}>{email}</span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            );
          }

          return (
            <div key={index} className="col-md-4">
              <Link to={card.link} className="text-decoration-none">
                <div className="flip-card">
                  <div className="flip-card-inner">
                    <div className="flip-card-front">
                      <div className="card h-100 border-0">
                        <div className="card-body d-flex flex-column justify-content-center align-items-center text-center p-4">
                          <div className={`card-icon ${card.frontIcon.type === IoSettingsOutline ? 'rotate-icon' : ''}`}>
                            {card.frontIcon}
                          </div>
                          <h3 className="card-title mt-3">{card.title}</h3>
                          <div className="email-section-front mt-3">
                            {getAllEmails(card.email).map((email, idx) => (
                              <div key={idx} className="email-front d-flex align-items-center justify-content-center gap-2" style={{marginBottom: '6px'}}>
                                <FaEnvelope size={12} />
                                <small className="email-text-front">
                                  {email}
                                </small>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flip-card-back">
                      <div className="card h-100 border-0">
                        <div className="card-body d-flex flex-column justify-content-center align-items-center text-center p-4">
                          <h3 className="card-title servicestitle mb-2 mt-4">{card.backTitle}</h3>
                          <p className="card-text servicesdesc m-0">
                            {card.backText}
                          </p>
                          <div className="email-section-back  mb-4">
                            <hr className='m-2' style={{opacity:"1"}}/>
                            <small>Email:</small>
                            <div className="email-back">
                              {getAllEmails(card.email).map((email, idx) => (
                                <div key={idx} className="email-item d-flex align-items-center justify-content-center gap-2">
                                  <FaEnvelope size={10} />
                                  <span>{email}</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FlipCards;